/* eslint-disable comma-dangle */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Chip,
  TextField,
  Select,
  MenuItem,
  Paper,
  Typography,
  Tooltip,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from "@mui/material";
import {
  Lock,
  ExpandMore,
  Help,
} from '@mui/icons-material';
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { 
  getDEXCollisionIDs, 
  respDEXCollisionIDs, 
  getDEXHighCall, 
  respDEXHighCall,
  getDEXNoCall,
  respDEXNoCall,
  vdi_json,
  getDexProviderCallsPerDay,
  respDEXPCPD,
} from "../../utils/GetAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import {formatDate, formatDateTime, getUniqueStringList} from "../../utils/Formatter";
import AdminOptimization from "../admin/AdminOptimization";
import ProtectBeverageCategory from "../admin/ProtectBeverageCategory";
import TradeSubtradeConfig from "../admin/TradeSubtradeConfig";
import BottleCanConfig from "../admin/BottleCanConfig";
import requestMissingContexts, {
  displayConfig, 
  determineConfig, 
  determineConfigLong
} from "../../utils/GetContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%'
    },
    root: {
      margin: '0',
      padding:'0'

    },
    divWidth: {
      width: "100%"
    },
    gridSpaceable: {
      padding: theme.spacing(2)
    },
    gridMarginTop: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2)
    },
    checkbox: {
      padding: 0,
      "&$disabled": {
        color: theme.palette.primary.main
      }
    },
    navtab: {
      //backgroundColor: theme.palette.grey[100],
    },
    navtabsel: {
      backgroundColor: theme.palette.grey[400],
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150
    },
    
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
        width: '80%',
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
  }

function LoadingSpinner(){
  return (<CircularProgress />)
}


function handleCustNumClick(customerNum: string){
  window.open(`/customer/${customerNum}`, "_blank");
}

function EqpStatus(params: {status:string}){
  const c:{[key:string]:string} = {
      INIT: "yellow",
      DISP:"red",
      NOPH:"red",
      PREM:"red",
  }
  let color = c[params.status] || "green"
  return ( 
    <Button
      variant="outlined"
      style={{ padding: "0px",  color }}
      disabled={true}
      disableElevation
    >
      {params.status}
    </Button>
  )
}

function VdiStatus(params: {codes:any, status:string}){
  const codes = params.codes
  const status = params.status
  const c:{[key:string]:string} = {
    R: "black",
    I: "black",
    U: "red",
    A: "red",
    E: "red",
    S: 'green',
    F: 'orange',
  }
  let color = c[params.status] || "black"
  return ( 
    <Tooltip title={determineConfigLong(codes, "dex_vdi_status", status)}>
      <Button
        variant="outlined"
        style={{ padding: "0px", color}}
        disabled={true}
        disableElevation
      >
        {determineConfig(codes, "dex_vdi_status", status)}
      </Button>
    </Tooltip>
  )
}


function VdiReason(params: {codes:any, status:string}){
  const codes = params.codes
  const status = params.status
  const c:{[key:string]:string} = {
    0: "black",
    1: 'green',
  }
  let color = c[params.status] || "black"
  return ( 
    <Tooltip title={determineConfigLong(codes, "dex_vdi_reason", status.toString())}>
      <Button
        variant="outlined"
        style={{ padding: "0px", color}}
        disabled={true}
        disableElevation
      >
        {determineConfig(codes, "dex_vdi_reason", status.toString())}
      </Button>
    </Tooltip>
  )
}


export default function Configurations() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [codes, setCodes] = React.useState<any>();
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const controlAdj = 55;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj - controlAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })

  const [curTab, setCurTab] = React.useState<number>(0);
  const subtabs = [
    {
      title: "Optimization",
      content: <AdminOptimization/>
    },
    {
      title: "Protect the Beverage Category",
      content: <ProtectBeverageCategory/>
    },
    {
      title: "Trade & Sub-Trade Channel",
      content: <TradeSubtradeConfig />
    },
    {
      title: "Bottle/CAN configuration",
      content: <BottleCanConfig />
    }
  ];

  const handleTabsChange = (_: React.ChangeEvent<{}>, value: any) => {
    const idx = subtabs?.findIndex((v: any) => v.title === value) || 0;
    setCurTab(idx);
  };
  
  useEffect(() => {
    if (doneLoading) return;

    setDoneLoading(true);
  }, [doneLoading,salesOrg]);
  
  return (
    <div>
      {enabled ? (
        <div className={classes.root}>
          <Paper className={classes.root}>
            <Tabs
              className={classes.navtab}
              onChange={handleTabsChange}
              value={subtabs[curTab].title}
              variant="fullWidth"
            >
               {subtabs.map((tab,i) =>
                     (<Tab
                        className={(i==curTab)?classes.navtabsel:classes.navtab}
                        key={tab.title}
                        label={tab.title}
                        value={tab.title}
                     />))}
            </Tabs>
            {subtabs[curTab].content}
          </Paper>
        </div>
      ) : (
        <Alert severity="error">
          <AlertTitle><Lock/> Access Error</AlertTitle>   
          You do not currently have access to <strong>CONA Internal Support</strong> 
          activities for the <strong>{salesOrg}</strong> bottler. 
        </Alert>
      )}
    </div>
   )
}


function ISupDEXCollisionIDs(params: {tableBodyHeight:string, clientId:string, salesOrg:string}) {
  const classes = useStyles();
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  
  const clientId = params.clientId;
  const salesOrg = params.salesOrg;

  const [DEXCollisionIDs, setDEXCollisionIDs] = React.useState<respDEXCollisionIDs>();

  useEffect(() => {
    if (doneLoading) return;
    getDEXCollisionIDs(clientId,salesOrg).then( (cids) =>{setDEXCollisionIDs(cids);});
    setDoneLoading(true);
  }, [clientId, doneLoading, salesOrg]);

  return (
    <div>
      <TableAbstraction
        settingsKey="ADM_IS_DEX_CID"
        options={{
          draggableColumns: {
            enabled: true
          },
          rowsPerPageOptions: [50, 100, 500],
          tableBodyHeight:params.tableBodyHeight,
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          }
        }}
        title={'Duplicate Device ID Detection'}
        columns={[
          {
            label: "Device ID Key",
            name: "device_id_key",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Collision Count",
            name: "collision_count",
            options: {
              hint: [ "Number of duplicate Device ID Keys in the database.",
                      "This indicates DEX messages may not proccess correctly",
                      "for the noted Telemeter if this is greater than 1."].join(' '),
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sub Serial Num",
            name: "sub_serial_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Equipment",
            name: "equipment_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Customer",
            name: "customer_num",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Chip
                  label={value}
                  variant="outlined"
                  size="small"
                  onClick={() => handleCustNumClick(value)}
                />
              ) ,
            }
          },
          {
            label: "Sales Org",
            name: "sales_org",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Plant",
            name: "delivering_plant",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "E Act",
            name: "eqp_active",
            options: {
              hint:"Equipment Active Indicator",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "E Inv",
            name: "eqp_invalid",
            options: {
              hint:"Equipment Invalid Indicator",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "E Stat",
            name: "eqp_status",
            options: {
              hint:"Equipment Status Indicator",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <EqpStatus status={value}  />
              ) ,
            }
          },
          {
            label: "C Act",
            name: "cust_active",
            options: {
              hint:"Customer Active Indicator",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "C Err",
            name: "customererrors",
            options: {
              hint:"Customer Errors",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "E Err",
            name: "materialerrors",
            options: {
              hint:"Equipment Errors",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Ord B",
            name: "central_order_block",
            options: {
              hint: "Central Order Block",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Dlv B",
            name: "central_delivery_block",
            options: {
              hint: "Central Delivery Block",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Supp",
            name: "supp_reason",
            options: {
              hint: "Suppression Reason",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Sal B",
            name: "central_sales_block",
            options: {
              hint: "Central Sales Block",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Dlt B",
            name: "central_deletion_block",
            options: {
              hint: "Central Deletion Block",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          }
        ]}
        data={DEXCollisionIDs?.dexCollisionIDs}
      />

    </div>
  )

}

function ISupDEXHighCall(params: {tableBodyHeight:string, clientId:string, salesOrg:string}) {
  const classes = useStyles();
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  
  const clientId = params.clientId;
  const salesOrg = params.salesOrg;

  const [DEXHighCall, setDEXHighCall] = React.useState<respDEXHighCall>();

  useEffect(() => {
    if (doneLoading) return;
    getDEXHighCall(clientId,salesOrg).then( (hc) =>{setDEXHighCall(hc);});
    setDoneLoading(true);
  }, [doneLoading, salesOrg, DEXHighCall, clientId]);

  return (
    <div>
      <TableAbstraction
        settingsKey="ADM_IS_DEX_HC"
        loading={!doneLoading}
        options={{
          draggableColumns: {
            enabled: true
          },
          rowsPerPageOptions: [50, 100, 500],
          tableBodyHeight:params.tableBodyHeight,
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          }
        }}
        title={'High Frequency DEX Call-In'}
        columns={[
          {
            label: "Sales Org",
            name: "sales_org",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Plant",
            name: "delivering_plant",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Customer",
            name: "customer_num",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Chip
                  label={value}
                  variant="outlined"
                  size="small"
                  onClick={() => handleCustNumClick(value)}
                />
              ),
            }
          },
          {
            label: "Equipment",
            name: "equipment_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sub Serial",
            name: "sub_serial_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sub Manu Serial",
            name: "sub_manu_serial_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Last Transmission",
            name: "last_transmission_dt",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "total",
            name: "total",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Device ID",
            name: "deviceid",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "DA101",
            name: "da101",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 1",
            name: "transmit_1",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 1 -> 2",
            name: "diff_1_2",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 1 -> 2",
            name: "diff_1_2_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 2",
            name: "transmit_2",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 2 -> 3",
            name: "diff_2_3",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 2 -> 3",
            name: "diff_2_3_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 3",
            name: "transmit_3",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 3 -> 4",
            name: "diff_3_4",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 3 -> 4",
            name: "diff_3_4_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 4",
            name: "transmit_4",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 4 -> 5",
            name: "diff_4_5",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 4 -> 5",
            name: "diff_4_5_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 5",
            name: "transmit_5",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 5 -> 6",
            name: "diff_5_6",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 5 -> 6",
            name: "diff_5_6_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 6",
            name: "transmit_6",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
          {
            label: "Diff 6 -> 7",
            name: "diff_6_7",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Sec 6 -> 7",
            name: "diff_6_7_sec",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Transmit 7",
            name: "transmit_7",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDateTime(value)) ,
            }
          },
        ]}
        data={DEXHighCall?.dexHC}
      />
    </div>
  )
}



function ISupDEXNoCall(params: {tableBodyHeight:string, clientId:string, salesOrg:string}) {
  const classes = useStyles();
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [showVdiHistory, setShowVdiHistory] = React.useState<vdi_json[]|undefined>();
  const [codes, setCodes] = React.useState<any>();
  const [modalStyle] = React.useState(getModalStyle);
  
  const clientId = params.clientId;
  const salesOrg = params.salesOrg;

  const [DEXNoCall, setDEXNoCall] = React.useState<respDEXNoCall>();

  const [handleAlert, setHandleAlert] = useState(false);
  const [alert, setAlert] = useState("");

  useEffect(() => {
    if (doneLoading) return;
    getDEXNoCall(clientId,salesOrg).then( (nc) =>{setDEXNoCall(nc);});
    requestMissingContexts(["dex_vdi_status", "dex_vdi_reason"])
      .then((v) => {
        setCodes(v);
      })
    setDoneLoading(true);
  }, [doneLoading, salesOrg, DEXNoCall, clientId]);

  
  const VDIModalBody = (params: {})=>{
    const deviceid = showVdiHistory? showVdiHistory[0].deviceid : ''
    const da101 = showVdiHistory ? showVdiHistory[0].da101 : ''
    const providerid = showVdiHistory ? showVdiHistory[0].providerid : ''
    return (
      <div style={modalStyle} className={classes.paper} >
        <Typography variant="h4" className={classes.modalTitle} paragraph>
          VDI DEX Calls for {providerid}: {deviceid} / {da101}
        </Typography>
        <TableAbstraction
          settingsKey="ADM_IS_DEX_NC_VDI"
          loading={!doneLoading}
          options={{
            draggableColumns: {
              enabled: true
            },
            rowsPerPageOptions: [25],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            }
          }}
          columns={[
            {
              label: "Provider ID",
              name: "providerid",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "App ID",
              name: "applicationid",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "Device ID",
              name: "deviceid",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "DA101",
              name: "da101",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "Transaction ID",
              name: "transactionid",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "Read Time",
              name: "readdatetime",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "Transmit Time",
              name: "transmittime",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "Transaction Time",
              name: "transactiontime",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "File Size",
              name: "filesize",
              options: {
                searchable: false,
                filter: false,
              }
            },
            {
              label: "DEX Reason",
              name: "dexreason",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value) => (
                  <VdiReason codes={codes} status={value} />
                ) ,
              }
            },
            {
              label: "DEX Status",
              name: "status",
              options: {
                searchable: false,
                filter: false,
                customBodyRender: (value) => (
                  <VdiStatus codes={codes} status={value}/>
                ) ,
              }
            },
          ]}
          data={showVdiHistory}
        />
      </div>
    );
  };

  return (
    <div>
      <TableAbstraction
        settingsKey="ADM_IS_DEX_NC"
        loading={!doneLoading}
        options={{
          draggableColumns: {
            enabled: true
          },
          rowsPerPageOptions: [25, 100, 500],
          tableBodyHeight:params.tableBodyHeight,
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          }
        }}
        title={'Missing DEX Call-In'}
        columns={[
          {
            label: "Sales Org",
            name: "sales_org",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Plant",
            name: "delivering_plant",
            options: {
              searchable: true,
              filter: true,
            }
          },
          {
            label: "Route",
            name: "master_route",
            options: {
              searchable: true,
              filter: true,
            }
          },
          {
            label: "Customer",
            name: "customer_num",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Chip
                  label={value}
                  variant="outlined"
                  size="small"
                  onClick={() => handleCustNumClick(value)}
                />
              ) ,
              
            }
          },
          {
            label: "Equipment",
            name: "equipment_num",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Er Fail",
            name: "failed_to_update",
            options: {
              hint:"ERROR Failed To Update Tracking With Latest Dex Message. This may be as a result of an equipment swap that hasnt proccessed DEX yet, a bad DEX file, or there may be an issue on CONA's side.",
              searchable: true,
              filter: false,
              customBodyRender: (value) => (
                <Tooltip title={value}>
                  <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
                </Tooltip>
              ) ,
            }
          },        {
            label: "Er No Call",
            name: "no_call_in",
            options: {
              hint:"ERROR We do not have recent DEX data for the telemeter ID. Either we are not being forwarded it from the 3rd party vender, or it is not being sent from the machine.",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Er ID MM",
            name: "device_id_missmatch",
            options: {
              hint:"ERROR Device ID missmatch. The DEX tracking table has a different ID than is currently assigned to the equipment in the masterdata. ",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Er SE Dupe",
            name: "dupe_sub_eqp",
            options: {
              hint:"ERROR Sub Equipment Duplication. The Sub Equipment is assigned to multiple equipments in the database. This causses issues when assigning DEX data to the correct equipment.",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "Model",
            name: "model",
            options: {
              hint:"Equipment Model",
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Status",
            name: "status",
            options: {
              hint:"Equipment Status",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <EqpStatus status={value}  />
              ) ,
            }
          },
          {
            label: "C Err",
            name: "customererrors",
            options: {
              hint:"Customer Errors",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "E Err",
            name: "materialerrors",
            options: {
              hint:"Equipment Errors",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "E Inv",
            name: "invalid",
            options: {
              hint:"Equipment Invalid Indicator",
              searchable: false,
              filter: false,
              customBodyRender: (value) => (
                <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
              ) ,
            }
          },
          {
            label: "SE Man",
            name: "manufacturer",
            options: {
              hint:"Sub Equipment Manufacturer",
              searchable: false,
              filter: false,
            }
          },
          {
            label: "SE SNum",
            name: "sub_serial_num",
            options: {
              hint:"Sub Equipment Serial Num",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "SE M SNum",
            name: "sub_manu_serial_num",
            options: {
              hint:"Sub Equipment Manufacturer Serial Num",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "SE Dupe",
            name: "sub_eqp_used_elsewhere",
            options: {
              hint:"Sub Equipment Duplication",
              searchable: true,
              filter: false,
              customBodyRender: (value) => (
                <Tooltip title={value}>
                  <Checkbox checked={!!value} disabled={true} className={classes.checkbox} />
                </Tooltip>
              ) ,
            }
          },
          {
            label: "Cust Last Visit",
            name: "last_visit_dt",
            options: {
              hint:"Customer's last visit date",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "DTrk Last",
            name: "last_tx_dex_dt",
            options: {
              hint:"DEX Tracking Last Proccessed DEX Date",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "DTrk Src",
            name: "last_tx_dex_source",
            options: {
              hint:"DEX Tracking Last update source",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "DTrk DID",
            name: "dt_device_id",
            options: {
              hint:"DEX Tracking Device ID",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "DTrk DA101",
            name: "dt_da101",
            options: {
              hint:"DEX Tracking DA101",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "VDI DID",
            name: "deviceid",
            options: {
              hint:"VDI Last Call Device ID",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "VDI DA101",
            name: "da101",
            options: {
              hint:"VDI Last Call DA101",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "VDI Last Dt",
            name: "max_dt",
            options: {
              hint:"VDI Last recieved message date ",
              searchable: true,
              filter: false,
            }
          },
          {
            label: "VDI Count",
            name: "vdi_json",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value:vdi_json[]) => {
                let count = 0
                if(value){
                  count = value.length
                }
                return (
                  <Chip
                    label={count>5?`5+`:count}
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setShowVdiHistory(value);
                      if(!value.length){
                        setHandleAlert(true);
                        setAlert("No recent DEX calls available.")
                      }
                    }}
                  />
                )
              },
            }
          },
        ]}
        data={DEXNoCall?.dexNC}
      />
      {(showVdiHistory && showVdiHistory.length) ? <Modal
        open={!!showVdiHistory}
        onClose={()=>setShowVdiHistory(undefined)}
      >
        <VDIModalBody/>
      </Modal> : <Dialog
        open={handleAlert}
        onClose={() => {
          setHandleAlert(false);
          setAlert("");
        }}
      >
        <DialogTitle>Missing DEX Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>{alert}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setHandleAlert(false);
              setAlert("");
            }}
            color="primary"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>}
    </div>
  )
}

function ISupDEXCPD(params: {tableBodyHeight:string, clientId:string, salesOrg:string}) {
  const classes = useStyles();
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  
  const clientId = params.clientId;
  const salesOrg = params.salesOrg;

  const [DexCPD, setDexCPD] = React.useState<respDEXPCPD>();

  useEffect(() => {
    if (doneLoading) return;
    getDexProviderCallsPerDay(clientId,salesOrg).then( (dexCPD) =>{setDexCPD(dexCPD);});
    setDoneLoading(true);
  }, [doneLoading, salesOrg, DexCPD, clientId, muiTable]);

  return (
    <div>
      <TableAbstraction
        settingsKey="ADM_IS_DEX_HC"
        loading={!doneLoading}
        options={{
          draggableColumns: {
            enabled: true
          },
          rowsPerPageOptions: [25, 50, 100],
          tableBodyHeight:params.tableBodyHeight,
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          }
        }}
        title={'DEX Provider Calls Per Day'}
        columns={[
          {
            label: "Provider ID",
            name: "providerid",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Application ID",
            name: "applicationid",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Date",
            name: "dex_date",
            options: {
              searchable: false,
              filter: false,
              customBodyRender: (value) => (formatDate(value)) ,
            }
          },
          {
            label: "Unique Calls",
            name: "unique",
            options: {
              searchable: false,
              filter: false,
            }
          },
          {
            label: "Total Calls",
            name: "calls",
            options: {
              searchable: false,
              filter: false,
            }
          },
        ]}
        data={DexCPD?.dexCPD}
      />
    </div>
  )
}
